import {
    RetentionPoliciesOption,
    loadActiveRetentionPolicies,
} from 'owa-retention-policies-option';
import { OptionSubCategory } from 'owa-options-core';
import { trace } from 'owa-trace';

const retentionPoliciesSubCategory: OptionSubCategory = {
    key: 'retentionPolicies',
    titleStringKey: 'optionSubcategory_retentionPolicies',
    options: [RetentionPoliciesOption],
    onSelected: () => loadRetentionPoliciesList(),
};

async function loadRetentionPoliciesList(): Promise<boolean> {
    try {
        await loadActiveRetentionPolicies();
        return true;
    } catch (error) {
        trace.warn(error.message);
        return false;
    }
}

export default retentionPoliciesSubCategory;
